import { constants as config } from '@config';
import { logError } from 'src/utils/logger';

const ImagesFactory = require('../../../factory/images');

const GraphicCreator = require('./abstract/graphic');

module.exports = LogoCreator;

function LogoCreator () {}
LogoCreator.prototype = new GraphicCreator();
LogoCreator.prototype.constructor = LogoCreator;

LogoCreator.prototype.initialize = function () {
  GraphicCreator.prototype.initialize.call(this);

  this.mandatory = ['thumb_src'];
  _.extend(this.defaults, {
    is_vector: false,
    thumb_src: null,
    smart_asset: null
  });
};

LogoCreator.prototype.create = function (data) {
  // data['thumb_src'] = data['is_vector'] ? data['thumb_src']
  //   : ImagesFactory.getVersionUrl(data['thumb_src'], 'thumb');

  const element = this._createLogoContainer(data);
  const triggerEvent = _.bind(function () {
    this.trigger('', element.getAttribute('id'));
  }, this);

  if (data.is_vector) {
    data.content || this.fetchContent(element, data);
    data.content && this.updateContent(element, data);
    this.once('content', triggerEvent);
  } else {
    this._smartImageLoad(element, data);
    this.once('resolution_optimized', triggerEvent);
  }

  this.canvas.selectOnly([element]);

  return element.getAttribute('id');
};

LogoCreator.prototype.fetchContent = function (element, data) {
  const svgFile = data.thumb_src.replace(/(\.\w+)?$/, '.svg');

  // Fetch the CDN twice, in case the first one fails. Then try the S3 source.
  const fallbacks = [svgFile, svgFile, data.s3_source].filter(Boolean);

  const fetchWithFallback = (urls) => {
    if (urls.length === 0) {
      logError('LogoCreator.prototype.fetchContent', { urls });
      return;
    }

    const url = urls.shift();
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch ${url}`);
        }
        return response.text();
      })
      .then(content => {
        data.content = content;
        this.updateContent(element, data);
        this.trigger('fetch_content', element.getAttribute('id'));

        return content;
      })
      .catch(error => {
        logError('Error fetching SVG:', error);
        fetchWithFallback(urls);
      });
  };

  fetchWithFallback([...fallbacks]);
};

LogoCreator.prototype._createLogoContainer = function (data) {
  const attr = {
    id: this.canvas.getNextId(),
    class: 'element logo'
  };

  if (data.smart_asset) {
    attr[config.smartAssets.attributes.definedAsset] = data.smart_asset;
    attr[config.smartAssets.attributes.definedContentType] = config.smartAssets.typeToProperty.logos;
  }

  const logo = this.canvas.addSvgElementFromJson({ element: 'g', attr });
  const richData = this.getAddData(data);
  this._appendImageLogo(logo, richData);

  data.smart_asset && INKIVE.ImagesFactory.addBBoxValues(logo);

  return logo;
};

LogoCreator.prototype._smartImageLoad = function (element, data) {
  const image = $(element).children('image')[0];
  const size = svgedit.utilities.getBBox(image);

  this.trigger('optimize_resolution', element.getAttribute('id'));
  ImagesFactory.smartLoad(data.thumb_src, size, _.bind(function (status, optimusImage) {
    const canUpdateImage = status === INKIVE.C.Status.success || data.thumb_src;
    data.thumb_src = status === INKIVE.C.Status.success
      ? optimusImage.src
      : data.thumb_src;

    if (canUpdateImage) {
      image && image.setAttribute('xlink:href', data.thumb_src);
      this.trigger('resolution_optimized', element.getAttribute('id'));
    }
  }, this), false, { s3Source: data.s3_source });
};

LogoCreator.prototype._appendImageLogo = function (element, data) {
  const size = Math.max(data.width, data.height);

  const attr = {
    x: data.x,
    y: data.y,
    id: this.canvas.getNextId(),
    width: data.width ?? size,
    height: data.height ?? size,
    'xlink:href': data.url
  };

  const image = this.canvas.addSvgElementFromJson({ element: 'image', attr });

  element.appendChild(image);

  return image;
};

LogoCreator.prototype.updateContent = function (element, data) {
  GraphicCreator.prototype.updateContent.apply(this, arguments);
  this.trigger('content', element.getAttribute('id'), data);

  INKIVE.ImagesFactory.addBBoxValues();
};

LogoCreator.prototype.getAddData = function (data) {
  const getDefinedData = _.bind(this.getDefinedData, this, data);

  return {
    x: getDefinedData('position.x'),
    y: getDefinedData('position.y'),
    url: getDefinedData('thumb_src'),
    width: getDefinedData('size.width'),
    height: getDefinedData('size.height'),
    is_vector: data.is_vector,
    smart_asset: getDefinedData('smart_asset')
  };
};
